import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'townip-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.scss']
})
export class ModalFooterComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
  }

}
